// @flow

export const REQUEST_CREATE_RESET = 'REQUEST_CREATE_RESET'
export const REQUEST_CREATE_CREATE = 'REQUEST_CREATE_CREATE'
export const REQUEST_CREATE_CREATED = 'REQUEST_CREATE_CREATED'
export const REQUEST_CREATE_ERROR = 'REQUEST_CREATE_ERROR'
export const REQUEST_DATA_LOAD = 'REQUEST_DATA_LOAD'
